export enum ClassSignupAvailabilityStatus {
  AVAILABLE = "AVAILABLE",
  FUTURE_UNAVAILABLE = "FUTURE_UNAVAILABLE",
  NO_SIGNUP_UNAVAILABLE = "NO_SIGNUP_UNAVAILABLE",
  PAID_AVAILABLE = "PAID_AVAILABLE",
  STARTED_UNAVAILABLE = "STARTED_UNAVAILABLE",
  UNAVAILABLE = "UNAVAILABLE",
  WAITLIST_AVAILABLE = "WAITLIST_AVAILABLE",
}
